export type DomainErrorCode =
  | 'invalid'            // input failed validation
  | 'unavailable'        // dates clash with a hold, booking or owner block
  | 'wrong-state'        // action not allowed in the record's current phase
  | 'over-balance'       // payment larger than what is owed
  | 'not-found';

export class DomainError extends Error {
  constructor(public code: DomainErrorCode, message: string, public details?: unknown) {
    super(message);
    this.name = 'DomainError';
  }
}

export const fail = (code: DomainErrorCode, message: string, details?: unknown): never => {
  throw new DomainError(code, message, details);
};
